import { Injectable } from '@angular/core';
import {
  BASE_DAILY_CHALLENGE_STATE,
  DailyChallengeState,
} from '@kp/shared/components/daily-challenge/daily-challenge-status/daily-challenge-state';
import { DailyChallengeStatusApi } from '@kp/shared/components/daily-challenge/daily-challenge-status/daily-challenge-status.api';
import { DailyChallengeModel } from '@kp/shared/components/daily-challenge/daily-challenge.model';
import { BrowserStorage } from '@kservice';
import { DataStatus, Status, StatusMessage } from '@ktypes/models';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DailyChallengeStatusBloc {
  constructor(private _browserStorage: BrowserStorage, private _dailyChallengeStatusApi: DailyChallengeStatusApi) {}

  private _challengeStatusSubject = new BehaviorSubject<DataStatus<DailyChallengeModel>>(
    new DataStatus<DailyChallengeModel>(Status.starting, new StatusMessage(Status.starting, ''), null)
  );

  private _showLoadingState = true;

  get dailyChallengeStatus$(): Observable<DataStatus<DailyChallengeModel>> {
    return this._challengeStatusSubject.asObservable();
  }

  storeDailyChallengeState(state: DailyChallengeState = {}) {
    this._browserStorage.setObject(
      'daily_challenge_state',
      {
        ...BASE_DAILY_CHALLENGE_STATE,
        ...state,
      },
      null,
      null,
      'session'
    );
  }

  getDailyChallengeState(): DailyChallengeState {
    return this._browserStorage.getObject('daily_challenge_state', null, 'session') || BASE_DAILY_CHALLENGE_STATE;
  }

  refreshDailyChallengeStatus(): void {
    if (this._showLoadingState) {
      this._challengeStatusSubject.next(
        new DataStatus<DailyChallengeModel>(Status.starting, new StatusMessage(Status.starting, ''), null)
      );
      this._showLoadingState = false;
    }
    this._dailyChallengeStatusApi.getCurrentStatus().then((challengeStatus) => {
      if (challengeStatus) {
        const status = new DataStatus<DailyChallengeModel>(
          Status.done,
          new StatusMessage(Status.done, ''),
          challengeStatus.data?.[0]
        );
        this._challengeStatusSubject.next(status);
      }
    });
  }
}
